import { CampaignTypeEnum } from "./enums";

export const DEFAULT_CAMPAIGN_IMAGES: Record<number, string> = {
  [CampaignTypeEnum.Voucher]:
    "https://s3-ap-southeast-1.amazonaws.com/getzpay-dev/CampaignImage/AccountCode_DBA/81d8827b412c4640a708df57aac4725c.png",
  [CampaignTypeEnum.Point]:
    "https://s3-ap-southeast-1.amazonaws.com/getzpay-dev/CampaignImage/AccountCode_DBA/ba96f555d3d9459894db5feb33a91cbd.png",
  [CampaignTypeEnum.VoucherPoint]:
    "https://s3-ap-southeast-1.amazonaws.com/getzpay-dev/CampaignImage/AccountCode_DBA/69fae000189943539ccbf3889f313180.png",
  [CampaignTypeEnum.EVoucher]:
    "https://s3-ap-southeast-1.amazonaws.com/getzpay-dev/CampaignImage/AccountCode_DBA/c3b97a4982894aa3b63ec19d1c4d894f.png",
  [CampaignTypeEnum.Custom]:
    "https://s3-ap-southeast-1.amazonaws.com/getzpay-dev/CampaignImage/AccountCode_E32/641627a2586d4f089a6dd3e50775d04d.png",
};
